import React, { useEffect } from "react";

export const GoogleReviews = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://featurable.com/assets/bundle.js";
    script.defer = true;
    script.charset = "UTF-8";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="google-reviews" className="text-center py-10">
      <div className="container-google">
        <div className="section-title mb-8">
          <h2 className="text-3xl font-bold">Testimonios</h2>
        </div>
        {/* Featurable Reviews Embed */}
        <div
          id="featurable-d675906e-1776-4168-bea9-163b86d9e2fc"
          data-featurable-async
        ></div>
      </div>
    </section>
  );
};
